import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild, inject, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { NgFor, AsyncPipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { HotelService } from 'src/app/services/hotel.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators, FormControl, FormsModule, ReactiveFormsModule, FormArray } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { HotelCityService } from 'src/app/services/hotel-city.service';

import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MapGeocoder } from '@angular/google-maps';
import { DropDownInput } from 'src/app/util/drop-down/drop-down.component';
import * as mammoth from 'mammoth';
import {NotificationSettingsService} from 'src/app/services/notification-settings.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-hotel',
  templateUrl: './hotel.component.html',
  styleUrls: ['./hotel.component.css']
})
export class HotelComponent implements AfterViewInit {
  @Output() myOutput: EventEmitter<string> = new EventEmitter();
  outputMessage: string = "close";

  departure: any = 'Delhi'
  arrivel: any = 'Mumbai'
  departureTime: any
  arrivelTime: any
  separatorKeysCodes: number[] = [ENTER, COMMA];
  separatorKeysCodesTo: number[] = [ENTER, COMMA];
  minData = new Date()
  fruitCtrl = new FormControl('Delhi, Delhi,IN');
  filteredFruits: Observable<string[]>;
  ciytState: any = "Delhi, Delhi,IN"
  // allFruits:any = [];
  // allCities:any=["CTDEL Delhi,Delhi ","CTBOM  Mumbai,Maharashtra"]
  // whereTo:any=["CTBOM  Mumbai,Maharashtra ","CTDEL Delhi,India "]

  allCities: any = ["Delhi, Delhi,IN", "Mumbai, Maharashtra,IN", "Bangalore, Karnataka,IN", "Pune, Maharashtra,IN", "Kolkata, West Bengal,IN", "Goa, Goa,IN", "Hyderabad, Telangana,IN", "Chennai, Tamil Nadu,IN", "Rajkot, Gujarat,IN"]
  whereTo: any = ["Mumbai, Maharashtra,IN", "Delhi, Delhi,IN "]

  // whereTo:any=[];
  ToCtrl = new FormControl('Mumbai, Maharashtra,IN');
  filteredTo: Observable<string[]>;
  wherecity: any = "Mumbai, Maharashtra,IN"
  @ViewChild('CheckIn') CheckIn!: ElementRef<HTMLInputElement>;
  @ViewChild('pickers') datePicker!: ElementRef<HTMLInputElement>;

  announcer = inject(LiveAnnouncer);

  searchFg!: FormGroup

  showOneWay: boolean = false
  showReturn: boolean = false
  showMulti: boolean = false
  currentNumber: number = 1;
  ccurrentNumber: number = 0;
  icurrentNumber: number = 1;
  selectedItem: string = 'Economy';
  selectedPerson: string = 'Adult'
  adult: any;
  child: any;
  rooms: any;
  searchData: any
  cityData: any
  packageRate: boolean = false
  _searchingCity :string='I';
  tokenData:any={
    userUuid:''
  }
  constructor(private sanitizer: DomSanitizer,private NotificationSettingsService:NotificationSettingsService,private geoCoder:MapGeocoder,private ChangeDetectorRef:ChangeDetectorRef,private renderer: Renderer2, private data: DataService, private HotelService: HotelService, private router: ActivatedRoute, private route: Router, private fb: FormBuilder, private cdr: ChangeDetectorRef, private toastMsgService: ToastmsgService,
    private CityService: HotelCityService,private http: HttpClient,  private userInfoService : UserInfoService,) {
    this.data.portMessage.subscribe((message: any) => this.searchData = message)
      this.tokenData.userUuid=this.userInfoService.getUserUuid()

    // this.CityService.portMessage.subscribe((message: any) => this.cityData = message)
    // this.CityService.loadPopularCities();
    // this.CityService.loadOtherCities();
    setTimeout(() => {
      // this.getHotelCityList();
    }, 300);

    // console.log(this.searchData)
    //  console.log(this.searchData)
    let allCities: any = []

    if (this.searchData != "default message") {
      // this.intList = this.intList
      // this.domList = this.domList
      if ('location' in this.searchData) {
      if(this.searchData.location){
        this.pickUpLat = this.searchData?.location?.latitude;
        this.pickUpLong = this.searchData?.location?.longitude;
      }
    }
      this.type = this.searchData?.type || 'D'

      // console.log(this.intList)

      this.packageRate = this.searchData.rateType === 'HP' ? true : false
      //   let request:any={
      //     "city": this.searchFg.value.fromAirport,
      // "checkInDate": this.convertTimeZone(this.searchFg.value.requestedDate),
      // "checkOutDate": this.convertTimeZone(this.searchFg.value.returnDate),
      // "roomCount": this.searchFg.value.infantCount,
      // "adultCount": this.searchFg.value.adultCount,
      // "childCount":this.searchFg.value.childCount,
      // // "rooms":roomsData,
      // "childrenAges":this.searchFg.value.childrenAges||[],
      // "isInternational":false,"isDomestic":false,
      //   }


      // console.log(this.searchData?.city)
      this.city=this.searchData?.city
      this.country=this.searchData?.country
      this.addresstextValue=this.searchData?.address
      // console.log(this.addresstextValue)
      this.searchFg = this.fb.group({
        "fromAirport": [this.searchData?.city, [Validators.required]],
        "toAirport": ["", [Validators.required]],
        "requestedDate": [this.convertZone(this.searchData?.checkInDate)],
        "requestedClass": [""],
        "paxCount": [0],
        "adultCount": [0],
        "childCount": [0],
        "infantCount": [0],
        "returnDate": [this.convertZone(this.searchData?.checkOutDate)],
        "menu": ['return'],
        // "childrenAges": this.fb.array(this.searchData?.childrenAges)

      });
      this.roomss = this.searchData?.rooms
      this.roomCount = this.searchData?.roomCount
      this.adult = this.calculateTotals(this.roomss).totalAdults + ` ` + "Adult"
      this.child = this.calculateTotals(this.roomss).totalChildren + ` ` + "Child"
      // this.currentNumber=this.searchData?.adultCount
      // this.ccurrentNumber=this.searchData?.childCount
      //   this.icurrentNumber=this.searchData?.roomCount
      // if(this.icurrentNumber>1){
      //   this.rooms=this.icurrentNumber+` `+"Rooms"

      // }else{
      //   this.rooms=this.icurrentNumber+` `+"Room"

      // }  
      // this.child=this.ccurrentNumber+` `+"Child"
      // this.adult=this.currentNumber+` `+"Adult"

      if (this.searchFg?.value?.requestedDate) {
        this.departureTime = this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
      }
      if (this.searchFg?.value?.returnDate) {
        this.arrivelTime = this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
      }
      // setTimeout(() => {
      //   // Add delay to ensure the user click event is captured
      //   if (this.type === 'D') {
      //     this.getHotelList(this.type)

      //   } else if (this.type === 'I') {
      //     this.getHotelIList(this.type)

      //   }
      // }, 200);
    } else {

      //this.getHotelDAPIList("D")
      // this.getHotelIAPIList("I")

      // this.intList = this.CityService.hotelCities
      // console.log(this.intList)
      if (this.type === 'D') {
        allCities = ["Delhi, Delhi,IN", "Mumbai, Maharashtra,IN", "Bangalore, Karnataka,IN", "Pune, Maharashtra,IN", "Kolkata, West Bengal,IN", "Goa, Goa,IN", "Hyderabad, Telangana,IN", "Chennai, Tamil Nadu,IN", "Rajkot, Gujarat,IN"]

      } else if (this.type === 'I') {
        allCities = ["Dubai, Dubai, United Arab Emirates,AE", "Singapore, Singapore,SG"]
      }
      this.adult = 1 + ` ` + "Adult"
      this.roomCount = 1
      this.roomss = [{
        adults: 1,
        childrenCount: 0,
        childrenAges: []
      }]
      this.dataFields()
      this.dataReturnFields()

    }


    if (this.roomCount > 1) {
      this.rooms = this.roomCount + ` ` + "Rooms"

    } else {
      this.rooms = this.roomCount + ` ` + "Room"

    }


    // this.searchFg.value.requestedDate=""
    //  this.rooms=this.icurrentNumber+` `+"Room"


    this.showOneWay = true
    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
      debounceTime(300), // Adjust the debounce time as needed
      distinctUntilChanged(),
      startWith(null),
      map((airport: any | null) => (airport ? this._filter(airport) : allCities.slice())),
    );
    this.filteredTo = this.ToCtrl.valueChanges.pipe(
      debounceTime(300), // Adjust the debounce time as needed
      distinctUntilChanged(),
      startWith(null),
      map((airports: any | null) => (airports ? this._filterTo(airports) : this.whereTo.slice())),
    );


  this.notificationlist()

  }

  setToInputStaticValue() {
    console.log("no no no")
    // Example: Set static value to the input element


    this.CheckIn.nativeElement.value = "Delhi,IN"

  }
  DisplayName: any
  ngOnInit(): void {
    let DisplayName: any
    this.router.queryParams.subscribe(params => {
      let data: any
      data = this.objectToArray(params)

      for (let i = 0; i < data.length; i++) {

        DisplayName += data[i];
      }

    });
  }
  objectToArray(obj: Record<string, string>): string[] {
    return Object.values(obj);
  }
  selectItem(item: string) {
    this.selectedItem = item;
  }
  selectPerson(item: string) {
    this.selectedPerson = item;
  }
  increment() {
    if (this.currentNumber < this.icurrentNumber * 4) {
      this.currentNumber++;
      this.adult = this.currentNumber + ` ` + "Adult"

    }
  }
  cIncrement() {
    if (this.ccurrentNumber < this.icurrentNumber * 3) {
      this.childrenAges.push(new FormControl(0));

      this.ccurrentNumber++;
      this.child = this.ccurrentNumber + ` ` + "Child"
    }
  }
  roomData: any = [{
    adults: 1,
    children: 0,
    childrenAges: []
  }]
  iIncrement() {
    if (this.icurrentNumber < 5) {
      this.icurrentNumber++;
      if (this.icurrentNumber > 1) {
        this.rooms = this.icurrentNumber + ` ` + "Rooms"

      } else {
        this.rooms = this.icurrentNumber + ` ` + "Room"

      }
    }
    if (this.icurrentNumber > 0) {
      let item: any = {
        adults: 1,
        children: 0,
        childrenAges: []
      }
      this.roomData.push(item)
    }

  }


  decrement() {
    if (this.currentNumber > 1) {
      this.currentNumber--;
      this.adult = this.currentNumber + ` ` + "Adult"

    }
  }
  cDecrement() {
    if (this.ccurrentNumber > 0) {
      this.childrenAges.removeAt(this.ccurrentNumber - 1);

      this.ccurrentNumber--;
      this.child = this.ccurrentNumber + ` ` + "Child"

    }
  }
  iDecrement() {
    if (this.icurrentNumber > 0) {
      this.icurrentNumber--;
      if (this.icurrentNumber > 1) {
        this.rooms = this.icurrentNumber + ` ` + "Rooms"

      } else {
        this.rooms = this.icurrentNumber + ` ` + "Room"

      }
      const maxAdults = this.icurrentNumber * 4;

      if (this.currentNumber > maxAdults) {
        this.currentNumber = maxAdults; // Reduce to the max allowed adults for the new number of rooms
        this.adult = this.currentNumber + ` ` + "Adult"

      }

      // Adjust children if necessary
      const maxChildren = this.icurrentNumber * 3;
      if (this.ccurrentNumber > maxChildren) {
        const excessChildren = this.ccurrentNumber - maxChildren;

        this.ccurrentNumber = maxChildren; // Reduce to the max allowed children for the new number of rooms
        // this.childrenAges.removeAt(this.ccurrentNumber-1);
        for (let i = 0; i < excessChildren; i++) {
          this.childrenAges.removeAt(this.childrenAges.length - 1);
        }
        this.child = this.ccurrentNumber + ` ` + "Child"


      }
    }
  }
  selectedDetail: boolean = false
  SelectDetail() {
    this.selectedDetail = true

  }
  closeDetail() {
    this.selectedDetail = false

  }
  showMultiCityFlight() {
    this.showOneWay = false
    this.showReturn = false
    this.showMulti = true
  }
  showOneWayFlight() {
    this.dataFields()
    this.showMulti = false
    this.showReturn = false
    this.showOneWay = true
  }
  showReturnFlight() {
    this.dataReturnFields()
    this.showMulti = false
    this.showReturn = true
    this.showOneWay = false
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.ciytState.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.fruitCtrl.setValue(null);
  }
  addTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our fruit
    if (value) {
      this.wherecity.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.ToCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.ciytState.indexOf(fruit);

    if (index >= 0) {
      this.ciytState.splice(index, 1);

      this.announcer.announce(`Removed ${fruit}`);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {

    this.ciytState = event.option.viewValue;
    this.fromAirportError = false
    //  console.log(event.option.viewValue)
    this.CheckIn.nativeElement.value = event.option.viewValue;
    // this.fruitCtrl.setValue(null);
    this.departure = event.option.viewValue?.split(',')[0]?.trim()

  }
  selectedTo(event: MatAutocompleteSelectedEvent): void {
    this.wherecity = event.option.viewValue;
    this.toAirportError = false

    // this.ToCtrl.setValue(null);
    this.arrivel = event.option.viewValue?.split(` `)[1]?.trim()?.split(',')[0]
  }
  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.allFruits.filter((fruit: any) => fruit.toLowerCase().includes(filterValue));
  // }

  private _filter(value: string): string[] {
    // Split the input value by comma and take the first part
    const filterValue = value.split(',')[0].toLowerCase().trim();

    // Use the filter method to create a new array containing only the matching ciytState
    return this.allCities.filter((fruit: any) => {
      // Split each fruit by comma and take the first part
      const Content = fruit.split(',')[0].toLowerCase().trim();
      const Content1 = fruit.split(',')[1].toLowerCase().trim();

      // Check if the lowercase fruit content includes the lowercase filterValue
      // return Content.includes(filterValue)||Content1.includes(filterValue);
      return Content.includes(filterValue)

    });
  }
  private _filterTo(value: string): string[] {
    // Split the input value by comma and take the first part
    const filterValue = value.split(',')[0].toLowerCase().trim();

    // Use the filter method to create a new array containing only the matching ciytState
    return this.whereTo.filter((fruit: any) => {
      // Split each fruit by comma and take the first part
      const whereTo = fruit.split(',')[0].toLowerCase().trim();
      const whereTo1 = fruit.split(',')[1].toLowerCase().trim();

      // Check if the lowercase fruit content includes the lowercase filterValue
      return whereTo.includes(filterValue)
    });
  }
  // private _filterTo(value: string): string[] {
  //   const filterValue = value.toLowerCase(); 
  //   return this.whereTo.filter((airport: any) => airport.toLowerCase().includes(filterValue));
  // }
  type: any = "D"
  onDOMINTChange(item: any) {
    // this.type=item.value
    if (item.value === 'D') {
      // this.pending=false

      let allCities = ["Delhi, Delhi,IN", "Mumbai, Maharashtra,IN", "Bangalore, Karnataka,IN", "Pune, Maharashtra,IN", "Kolkata, West Bengal,IN", "Goa, Goa,IN", "Hyderabad, Telangana,IN", "Chennai, Tamil Nadu,IN", "Rajkot, Gujarat,IN"]

      this.allCities = ["Delhi, Delhi,IN", "Mumbai, Maharashtra,IN", "Bangalore, Karnataka,IN", "Pune, Maharashtra,IN", "Kolkata, West Bengal,IN", "Goa, Goa,IN", "Hyderabad, Telangana,IN", "Chennai, Tamil Nadu,IN", "Rajkot, Gujarat,IN"]
      this.departure = "Delhi"
      this.CheckIn.nativeElement.value = "Delhi, Delhi,IN"
      this.ciytState = "Delhi, Delhi,IN"
      if (this.searchData != "default message") {

        this.searchData.city = "Delhi"
      }
      this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
        debounceTime(300), // Adjust the debounce time as needed
        distinctUntilChanged(),
        startWith(null),
        map((airport: any | null) => (airport ? this._filter(airport) : allCities.slice())),
      );
      this.getHotelList(item.value)

    } else if (item.value === 'I') {
      let allCities: any = ["Dubai, Dubai, United Arab Emirates,AE", "Singapore, Singapore,SG"]
      this.allCities = ["Dubai, Dubai, United Arab Emirates,AE", "Singapore, Singapore,SG"]
      this.departure = "Dubai"
      this.CheckIn.nativeElement.value = "Dubai, Dubai, United Arab Emirates,AE"
      this.ciytState = "Dubai, Dubai, United Arab Emirates,AE"
      if (this.searchData != "default message") {

        this.searchData.city = "Dubai"
      }
      this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
        debounceTime(300), // Adjust the debounce time as needed
        distinctUntilChanged(),
        startWith(null),
        map((airport: any | null) => (airport ? this._filter(airport) : allCities.slice())),
      );
      this.getHotelIList(item.value)

    }
  }
  intList: any
  domList: any
  pendingINT: boolean = false

  /*async getHotelIAPIList(type: any) {
    this.pendingINT = true
    try {
      const res: any = await firstValueFrom(this.HotelService.getcityList(type));
      if (res) {
        this.intList = res;
        this.pendingINT = false
        this.getHotelIList("I")

      }
    } catch (error) {
      this.pendingINT = false
      console.error("Error fetching hotel list:", error);
    }
  }*/
  // getHotelIAPIList(type:any){
  //  this.pending=true

  //   this.HotelService
  //   .getcityList(type)
  //   .subscribe({
  //     next : (res:any) => {
  //       this.pending=false

  //       if(res){
  //         this.intList=res

  //       }
  //     },error : (err) => {
  //       this.pending=false


  //           }})}
  pending: boolean = false;
  getHotelCityList() {
    // console.log( this.CityService.hotelCitiesDomestic)

    this.domList = this.CityService.hotelCitiesDomestic;
    this.intList=this.CityService.hotelCitiesInternational;
    this.pending=!this.CityService.citiesLoad.popularDomesticLoad;
    this.pendingINT=!this.CityService.citiesLoad.popularInternationalLoad;

    if (this.type === 'D') {
      if(this.domList?.length!=0){
        // console.log(this.domList)

        if(this.domList[0]?.length!=0){
          this.getHotelList(this.type)}

        }

    } else if (this.type === 'I') {
      if(this.intList?.length!=0){
        if(this.intList[0]?.length!=0){
          this.getHotelIList(this.type)}
        }
    }
    // console.log("international flag on first call == " + this.pendingINT);
    this.CityService.getCityLoadDomesticSub().subscribe({next : (param:any) => {
      this.domList = this.CityService.hotelCitiesDomestic;
      this.pending=!this.CityService.citiesLoad.popularDomesticLoad;

      // this.getHotelList("D");
      if (this.type === 'D') {
        this.getHotelList("D");
      } else if (this.type === 'I') {
        // this.getHotelIList(this.type)

      }
      // console.log("Domestic - ");
      // console.log(param);
    }});
    this.CityService.getCityLoadInternationalSub().subscribe({next : (param:any) => {
      this.intList=this.CityService.hotelCitiesInternational;
      this.pendingINT=!this.CityService.citiesLoad.popularInternationalLoad;
      // console.log("International - ");
      // console.log(param);
      //console.log("international flag on subscription == " + this.pendingINT);

 if (this.type === 'D') {

    } else if (this.type === 'I') {
      this.getHotelIList(this.type)

    }       
    }});
     if(!this.pending){
      this.getPlaceAutocomplete
     }
  }
  getHotelDAPIList(type: any) {
    this.pending = true
    this.HotelService
      .getcityList(type)
      .subscribe({
        next: (res: any) => {
          this.pending = false
          if (res) {
            this.domList = res

            this.getHotelList("D")

          }
        }, error: (err) => {

          this.pending = false

        }
      })
  }

  getHotelIList(type: any) {

    // this.HotelService
    // .getcityList(type)
    // .subscribe({
    //   next : (res:any) => {
    let res: any = this.intList
    this.allCities = []
    this.whereTo = []

    if (res) {
      let data: any
      //  data=res[0]
      let allowedCodes: any = []

      allowedCodes = ['Dubai', 'Singapore'];



      const first = res[0].filter((item: any) => allowedCodes.includes(item.cityName));
      const last = res[0].filter((item: any) => allowedCodes.every((code: any) => item.cityName !== code));
      data = [...first, ...last]

      for (let i = 0; i < data.length; i++) {
        this.allCities.push(data[i].cityLabel + `,` + data[i].countryCode);
      }
      if (this.searchData?.city) {
        const fromAirportDataRaw = data.filter((itm: any) => itm?.cityLabel.split(',')[0]?.trim() === this.searchData?.city);

        let fromAirportData = fromAirportDataRaw[0];
        let fromAirportString: any = fromAirportData?.cityLabel + `,` + fromAirportData?.countryCode
        this.CheckIn.nativeElement.value = fromAirportString     //toAirData={option:{viewValue:toAirData}}
        this.ciytState = fromAirportString;
        // this.fruitCtrl.setValue(null);
        // console.log( this.ciytState)

        // const  toAirportDataRaw = data.filter((itm:any)=>itm.iataCode===this.searchData.airSearchRequestBaseDetails[0].toAirport);
        // let toAirportData = toAirportDataRaw[0];
        // let toAirportString = toAirportData?.iataCode+`\u00A0 `+toAirportData?.city+`,`+toAirportData?.country+` - `+toAirportData?.name
        // this.wherecity=toAirportString;
        // this.departure= fromAirportString?.split(` `)[1]?.trim()?.split(',')[0]
        this.departure = fromAirportString?.split(',')[0]?.trim()
        // this.arrivel=toAirportString?.split(` `)[1]?.trim()?.split(',')[0]
        // this.ToCtrl.setValue(null);


      } else {

        this.CheckIn.nativeElement.value = "Dubai, Dubai, United Arab Emirates,AE"
        this.departure = "Dubai"
        this.ciytState = "Dubai, Dubai, United Arab Emirates,AE"


      }


    } else {
    }
    //       },error : (err) => {
    // console.log(err)

    //       }
    //     }
    //   )
  }


  getHotelList(type: any) {

    // this.HotelService
    // .getcityList(type)
    // .subscribe({
    //   next : (res:any) => {
    let res: any = this.domList
    this.allCities = []
    this.whereTo = []

    if (res) {
      let data: any
      //  data=res[0]
      let allowedCodes: any = []
      allowedCodes = ['Delhi', 'Mumbai', 'Bangalore', 'Pune', 'Kolkata', "Goa", "Hyderabad", "Chennai", "Rajkot"];



      const first = res[0].filter((item: any) => allowedCodes.includes(item.cityName));
      const last = res[0].filter((item: any) => allowedCodes.every((code: any) => item.cityName !== code));
      // console.log(last)
      data = [...first, ...last]

      for (let i = 0; i < data.length; i++) {
        this.allCities.push(data[i].cityLabel + `,` + data[i].countryCode);
      }
      if (this.searchData?.city) {

        const fromAirportDataRaw = data.filter((itm: any) => itm?.cityLabel.split(',')[0]?.trim() === this.searchData?.city);

        let fromAirportData = fromAirportDataRaw[0];
        let fromAirportString: any = fromAirportData?.cityLabel + `,` + fromAirportData?.countryCode
        // console.log(fromAirportString)
        this.CheckIn.nativeElement.value = fromAirportString     //toAirData={option:{viewValue:toAirData}}
        this.ciytState = fromAirportString;
        // this.fruitCtrl.setValue(null);
        // console.log( this.ciytState)

        // const  toAirportDataRaw = data.filter((itm:any)=>itm.iataCode===this.searchData.airSearchRequestBaseDetails[0].toAirport);
        // let toAirportData = toAirportDataRaw[0];
        // let toAirportString = toAirportData?.iataCode+`\u00A0 `+toAirportData?.city+`,`+toAirportData?.country+` - `+toAirportData?.name
        // this.wherecity=toAirportString;
        // this.departure= fromAirportString?.split(` `)[1]?.trim()?.split(',')[0]
        // console.log(fromAirportString)
        this.departure = fromAirportString?.split(',')[0]?.trim()
        // this.arrivel=toAirportString?.split(` `)[1]?.trim()?.split(',')[0]
        // this.ToCtrl.setValue(null);


      } else {
        // this.wherecity = "Mumbai, Maharashtra,IN"
        // this.ciytState = "Delhi, Delhi,IN"
        // if(this.CheckIn?.nativeElement?.value)
        //   this.CheckIn.nativeElement.value = "Delhi, Delhi,IN"
        // this.departure = "Delhi"
        // this.arrivel = "Mumbai"

      }


    } else {
    }
    //       },error : (err) => {
    // console.log(err)

    //       }
    //     }
    //   )
  }


  uuids: any = []
  searchClick() {
    let date: any = new Date().getDate();

    // console.log(date)
    let uu: any
    // console.log(uu)

    this.uuids.push(this.generateUUIDv4())
    // console.log(this.uuids)


  }
  generateUUIDv4(): string {
    let date: any = new Date().getDate();
    let time: any = new Date().getTime();
    let uuidDate: any = date + time;
    // console.log(date+"t"+time)
    return uuidDate + '-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  //   searchFlight(){
  //     //this.route.navigate(["/app/Flightlist"]);}
  //  window.location.href="/app/Flightlist"
  //   }

  dataFields() {
    const originalDate = new Date();
    const newDate = new Date(originalDate.setDate(originalDate.getDate() + 3));

    // const originalTimestamp =newDate;
    // const datePipe = new DatePipe('en-IN');

    // const newTimestamp = datePipe.transform(originalTimestamp, 'yyyy-MM-ddTHH:00:00.000Z');


    this.arrivelTime = ''
    this.searchFg = this.fb.group({
      "fromAirport": ['', [Validators.required]],
      "toAirport": [, [Validators.required]],
      "requestedDate": [newDate],
      "requestedClass": [''],
      "paxCount": [0],
      "adultCount": [0],
      "childCount": [0],
      "infantCount": [0],
      "returnDate": [],
      "menu": ['oneWay'],
      "childrenAges": this.fb.array([])

    });
    if (this.searchFg?.value?.requestedDate) {
      this.departureTime = this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
    }

    // console.log(this.searchFg?.value?.requestedDate)

  }


  dateFormate(date: any) {
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-IN');
    date = datePipe.transform(parsedDate, 'd MMM yyyy EEEE');
    // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
    return date

  }
  convertToISOStringFormat(dateString: any) {
    // Remove the ' 00:00' part and then add 'Z' at the end
    const isoDateString = dateString.replace('00.000 00:00', '00.000Z');
    return isoDateString;
  }
  areDatesEqual(date1: Date, date2: Date): boolean {
    // Compare year, month, and day to check if the dates are equal
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }
  onChangeDate() {
    // this.searchFg.value.returnDate=this.date1Plus(this.searchFg.value.requestedDate)
    // if(this.searchFg.value.menu==='return'){
    if (this.searchFg.value.requestedDate) {
      let date: any = new Date();
      if (this.areDatesEqual(this.searchFg.value.requestedDate, date)) {
        // Your code for the condition when dates are the same
        this.searchFg.value.requestedDate = new Date()
      } else {
        // Your code for the condition when dates are not the same
      }
    }

    this.searchFg = this.fb.group({
      "fromAirport": [this.searchFg.value.fromAirport, [Validators.required]],
      "toAirport": [this.searchFg.value.toAirport, [Validators.required]],
      "requestedDate": [this.searchFg.value.requestedDate],
      "requestedClass": [this.searchFg.value.requestedClass],
      "paxCount": [this.searchFg.value.paxCount],
      "adultCount": [this.searchFg.value.adultCount],
      "childCount": [this.searchFg.value.childCount],
      "infantCount": [this.searchFg.value.infantCount],
      "returnDate": [this.date1Plus(this.searchFg.value.requestedDate)],
      "menu": []
    });
  }

  onOneWayDate() {
    if (this.searchFg?.value?.requestedDate) {
      this.departureTime = this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
    }
    if (this.searchFg.value.requestedDate) {
      let date: any = new Date();
      if (this.areDatesEqual(this.searchFg.value.requestedDate, date)) {
        // Your code for the condition when dates are the same
        this.searchFg.value.requestedDate = new Date()
      } else {
        // Your code for the condition when dates are not the same
      }
    }
    if (this.searchFg.get('returnDate')?.value) {

  const returnDate = new Date(this.searchFg.get('returnDate')?.value);
  const requestedDate = new Date(this.searchFg.get('requestedDate')?.value);

  if ( requestedDate > returnDate) {

    const newReturnDate = this.date1Plus(requestedDate);
    this.searchFg.get('returnDate')?.setValue(newReturnDate);
      this.arrivelTime=this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
    
    
  }
}
    console.log(this.searchFg?.value?.childrenAges)
    this.searchFg = this.fb.group({
      "fromAirport": [this.searchFg?.value?.fromAirport, [Validators.required]],
      "toAirport": [this.searchFg?.value?.toAirport, [Validators.required]],
      "requestedDate": [this.searchFg?.value?.requestedDate],
      "requestedClass": [this.searchFg?.value?.requestedClass],
      "paxCount": [this.searchFg?.value?.paxCount],
      "adultCount": [this.searchFg?.value?.adultCount],
      "childCount": [this.searchFg?.value?.childCount],
      "infantCount": [this.searchFg?.value?.infantCount],
      "returnDate": [this.searchFg?.value?.returnDate],
      "menu": [this.searchFg?.value?.menu],
      "childrenAges": this.fb.array(this.searchFg?.value?.childrenAges)

    });


  }

  onRChangeDate() {
    if (this.searchFg?.value?.requestedDate) {
      this.arrivelTime = this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
    }
    this.showReturn = true
    this.showOneWay = false

    if (this.searchFg?.value?.returnDate) {
      let date: any = new Date();
      if (this.areDatesEqual(this.searchFg.value.returnDate, date)) {
        // Your code for the condition when dates are the same
        this.searchFg.value.returnDate = new Date()
      } else {
        // Your code for the condition when dates are not the same
      }


    }
    this.searchFg = this.fb.group({
      "fromAirport": [this.searchFg?.value?.fromAirport, [Validators.required]],
      "toAirport": [this.searchFg?.value?.toAirport, [Validators.required]],
      "requestedDate": [this.searchFg?.value?.requestedDate],
      "requestedClass": [this.searchFg?.value?.requestedClass],
      "paxCount": [this.searchFg?.value?.paxCount],
      "adultCount": [this.searchFg?.value?.adultCount],
      "childCount": [this.searchFg?.value?.childCount],
      "infantCount": [this.searchFg?.value?.infantCount],
      "returnDate": [this.searchFg?.value?.returnDate],
      "menu": ["return"],
      "childrenAges": this.fb.array(this.searchFg?.value?.childrenAges)

    });
    if (this.searchFg?.value?.returnDate) {
      this.arrivelTime = this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
    }
  }
  dataReturnFields() {


    this.searchFg = this.fb.group({
      "fromAirport": [this.searchFg?.value?.fromAirport, [Validators.required]],
      "toAirport": [this.searchFg?.value?.toAirport, [Validators.required]],
      "requestedDate": [this.searchFg?.value?.requestedDate],
      "requestedClass": [this.searchFg?.value?.requestedClass],
      "paxCount": [0],
      "adultCount": [0],
      "childCount": [0],
      "infantCount": [0],
      "returnDate": [this.date1Plus(this.searchFg.value.requestedDate)],
      "menu": ['return'],
      "childrenAges": this.fb.array([])
    });
    if (this.searchFg?.value?.returnDate) {
      this.arrivelTime = this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
    }
  }

  fromAirportError: boolean = false
  toAirportError: boolean = false
  searchHotel() {
    if(this.city){
    this.selectedDetail = false

    //console.log(this.searchFg.value.requestedDate)
    this.searchFg.value.childCount = this.ccurrentNumber
    this.searchFg.value.adultCount = this.currentNumber
    this.searchFg.value.infantCount = this.icurrentNumber
    // this.searchFg.value.paxCount=this.searchFg.value.childCount+this.searchFg.value.adultCount

    this.searchFg.value.toAirport = this.wherecity?.split(` `)[0].trim()
    this.searchFg.value.fromAirport = this.ciytState.split(',')[0]?.trim()

  
    let location:any

    if(this.pickUpLat){
       location={
        latitude : this.pickUpLat,
        longitude:this.pickUpLong
      }
    }else{
      location=undefined
    }
   
    let request: any = {
      // "city": this.searchFg.value.fromAirport,
      "city":this.city,
      "checkInDate": this.convertTimeZone(this.searchFg.value.requestedDate),
      "checkOutDate": this.convertTimeZone(this.searchFg.value.returnDate),
      "roomCount": this.roomCount,

      "rooms": this.roomss,
      // "rateType": this.packageRate ? "HP" : 'HO',
      // "country": this.ciytState.split(',')[this.ciytState.split(',').length - 1]?.trim(),
      "country":this.country||'IN',
      "type": this.type,
      "location":location,
      "address":this.address
    }

    this.uuids = this.generateUUIDv4()
    request.requestId = this.uuids
    this.data.deliverMsg(request)
    let cityRequest: any = {
      intList: this.intList,
      domList: this.domList
    }


    this.CityService.deliverMsg(cityRequest)

    this.myOutput.emit(this.outputMessage);

    this.route.navigate(["/app/hotellist"]);
  }else{
    this.toastMsgService.setMsg({msg : "Please select the compulsory field ",msgTitle:  "Warning", msgType : "W"});

  }


  }

  date1Plus(item: any) {
    const originalDate = new Date(item);
    const newDate = new Date(originalDate.setDate(originalDate.getDate() + 1));
    return newDate
  }
  clearCity: boolean = false
  AddCity: boolean = false
  array: any = [{
    "requestedDate": "",
    "requestedClass": "",
    "fromAirport": "",
    "toAirport": ""
  }, {
    "requestedDate": "",
    "requestedClass": "",
    "fromAirport": "",
    "toAirport": ""
  },]
  clickMulticity() {
    let count: any = {
      "requestedDate": "",
      "requestedClass": "",
      "fromAirport": "",
      "toAirport": ""
    }
    this.array.push(count)

    // console.log(this.array)
    if (this.array.length > 5) {
      this.AddCity = true
    } else {
      this.AddCity = false

    }
    if (this.array.length > 2) {
      this.clearCity = true
    } else {
      this.clearCity = false

    }

  }
  clear() {
    this.AddCity = false

    if (this.array.length > 3) {
      this.clearCity = true
    } else {
      this.clearCity = false

    }
    this.array.splice(2, 1);

  }

  onMenuChange(event: any) {
    if (event.value === "oneWay") {
      this.arrivelTime = ''
      this.searchFg = this.fb.group({
        "fromAirport": [this.searchFg?.value?.fromAirport, [Validators.required]],
        "toAirport": [this.searchFg?.value?.toAirport, [Validators.required]],
        "requestedDate": [this.searchFg?.value?.requestedDate],
        "requestedClass": [''],
        "paxCount": [0],
        "adultCount": [0],
        "childCount": [0],
        "infantCount": [0],
        "returnDate": [],
        "menu": ['oneWay']
      });
      if (this.searchFg?.value?.requestedDate) {
        this.departureTime = this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
      }
      //this.searchFg.value.menu="oneWay"
      this.showMulti = false
      this.showReturn = false
      this.showOneWay = true
    } else if (event.value === "return") {
      //this.searchFg.value.menu="return"
      this.dataReturnFields()
      this.showMulti = false
      this.showReturn = true
      this.showOneWay = false
    } else if (event.value === "multiCity") {
      //this.searchFg.value.menu="multiCity"

      this.showOneWay = false
      this.showReturn = false
      this.showMulti = true
    }
  }




  isActive(route: string): boolean {
    return this.route.isActive(route, true);
  }

  showArrivel: boolean = false
  openAutocomplete(): void {
    this.showArrivel = true
    // Check if mat-autocomplete is defined
    this.ToCtrl.setValue(null);

    // this.ToCtrl.setValue(this.ToInput.nativeElement.value);





  }
  openDAutocomplete() {
    // Check if mat-autocomplete is defined
    this.fruitCtrl.setValue(null);
    this.renderer.selectRootElement(this.CheckIn.nativeElement).focus();

  }
  convertTimeZone(input: any) {
    const inputDateTime = input;
    const datePipe = new DatePipe('en-IN');

    let formattedDateTime: any = datePipe.transform(inputDateTime, 'yyyy-MM-dd');
    return formattedDateTime;
  }

  convertZone(input: any) {
    const inputDateTime = input;
    const datePipe = new DatePipe('en-IN');

    let formattedDateTime: any = datePipe.transform(inputDateTime, 'yyyy-MM-ddTHH:mm:ss.SSSZ');
    return formattedDateTime;
  }


  get childrenAges(): FormArray {
    return this.searchFg.get('childrenAges') as FormArray;
  }

  addChildAgeControl() {
    this.childrenAges.push(new FormControl(null));
  }

  removeChildAgeControl(index: number) {
    this.childrenAges.removeAt(index);
  }


  onlyNumberKey(event: any) {

    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }


  roomCount: number = 1;
  roomss: any[] = [];
  roomOptions: number[] = [1, 2, 3, 4, 5]; // You can change the number of room options
  adultOptions: number[] = [1, 2, 3, 4,5,6,7,8,9];
  childOptions: number[] = [0, 1, 2, 3,4,5,6,7,8,9];
  childAgeOptions: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  onRoomCountChange() {
    this.roomss = [];
    for (let i = 0; i < this.roomCount; i++) {

      this.roomss.push({
        adults: 1,
        childrenCount: 0,
        childrenAges: []
      });
    }
    if (this.roomCount > 1) {
      this.rooms = this.roomCount + ` ` + "Rooms"

    } else {
      this.rooms = this.roomCount + ` ` + "Room"

    }
    this.adult = this.calculateTotals(this.roomss).totalAdults + ` ` + "Adult"

    this.child = this.calculateTotals(this.roomss).totalChildren + ` ` + "Child"
  }

  onAdultChange() {
    this.adult = this.calculateTotals(this.roomss).totalAdults + ` ` + "Adult"

  }
  onChildrenCountChange(roomIndex: number) {
    const room = this.roomss[roomIndex];
    // console.log(room.childrenCount)
    room.childrenAges = Array.from({ length: room.childrenCount }, () => 1);
    // console.log(room.childrenAges)
    if (this.roomCount > 1) {
      this.rooms = this.roomCount + ` ` + "Rooms"

    } else {
      this.rooms = this.roomCount + ` ` + "Room"

    }
    this.adult = this.calculateTotals(this.roomss).totalAdults + ` ` + "Adult"
    this.child = this.calculateTotals(this.roomss).totalChildren + ` ` + "Child"
  }

  calculateTotals(data: any) {
    let totalAdults = 0;
    let totalChildren = 0;

    data.forEach((item: any) => {
      // Add to total adults
      totalAdults += typeof item.adults === 'string' ? parseInt(item.adults, 10) : item.adults;

      // Add to total children based on the childrenCount
      totalChildren += typeof item.childrenCount === 'string' ? parseInt(item.childrenCount, 10) : item.childrenCount;
    });

    return { totalAdults, totalChildren };
  }






  @ViewChild('addresstextInput', { static: false }) addresstextInput!: ElementRef;

  @Output() setAddress = new EventEmitter<any>();

  addresstextValue: string = '';
  adressType: string = 'geocode'; // default address type

  pickUpLocation: string = '';
  pickUpLat: any ;
  pickUpLong: any;

  ngAfterViewInit(): void {
    // this.getPlaceAutocomplete();
  }

  public getPlaceAutocomplete() {
    if (this.addresstextInput?.nativeElement && google?.maps?.places) {
      const autocomplete = new google.maps.places.Autocomplete(
        this.addresstextInput.nativeElement,
        {

          types: [this.adressType],
        }
      );

      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        this.invokeEvents(place);
      });
    } else {
      console.error('Autocomplete initialization failed. Element or API not loaded.');
    }
  }
city:any=''
country:any=''
address:any=''
branchFilterParams: DropDownInput={searchFieldName:"formatted_address",keyFieldName : "formatted_address",address:"formatted_address"};
invokeEvents(place:any)
{

}
  invokeEventss(itm: any) {
    // console.log(itm)
    this.CityService
    .selectGoogleCity(itm.place_id)
    .subscribe({
      next : (res:any) => {
        if(res) {
          let places=res
          // console.log(data)
          // this.suggestions=data
// console.log(places)
      
    const countryComponent = places?.find(
      (component:any) => component.types.includes('country')
    );
    // console.log(countryComponent)
    const countryCode = countryComponent?.short_name;
    const countryName = countryComponent?.long_name;
    let isCity : boolean=false;
    const cityTypes=['administrative_area_level_1','locality'];
    for(let i=0;i<cityTypes.length && !isCity;i++) {
      isCity = itm.types?.includes(cityTypes[i]);
    }

     if(isCity){

this.pickUpLat = null
this.pickUpLong = null;
     }else{
      this.pickUpLat = itm.location.latitude;
      this.pickUpLong = itm.location.longitude;
     }
     const addressComponents = places || [];

     const cityComponent = addressComponents.find((component: any) =>
     component.types.includes('locality') || component.types.includes('administrative_area_level_1')
   );
 
   const isOnlyRegionLevel = addressComponents.some((component: any) =>
     component.types.includes('administrative_area_level_1') || component.types.includes('locality')
   );

   const cityName = cityComponent?.long_name || itm.name || '';

     this.city=cityName
     this.country=countryCode
this.address=itm?.formatted_address
// console.log(this.address)
    this.fromAirportError = false
   
    this.departure =itm?.name
    this.addresstextValue=itm?.formatted_address
    this.suggestions = [];
    // this.setAddress.emit(place);
    this.ChangeDetectorRef.detectChanges();
  } else {
        
  } 
},error : (err) => {

}
}
)
  }



  query: string = '';
  suggestions: any[] = [];
  apiKey: string = 'YOUR_GOOGLE_API_KEY'; // 🔐 Replace with your actual key

  searchText="";
  onInput = async (e : any) => {
    this.searchText=e.text;
    
    if (e.text?.length < 3) {
      this.suggestions = [];
      return;
    }  
    if(this._searchingCity !="I") {
      this._searchingCity="Q";
     
      return;
    }
   this._searchingCity="R";

   const setSearchingCity = () => {
    const _t=this._searchingCity;
        this._searchingCity="I";
        if(_t=="Q") this.onInput({text : this.searchText});
   }
    await this.CityService
    .loadGoogleCity(e.text,null)
    .subscribe({
      next : (res:any) => {
        if(res) {
          let data=res
          // console.log(data)
          this.suggestions=data
// console.log();
        } else {
          this.suggestions=[];
        } 
        setSearchingCity();
      },error : (err) => {
        setSearchingCity();
      }
    }
  )
  }

  selectPlace(place: any) {
    this.query = place.description;
    this.suggestions = [];
    // 🔁 Optional: use Place Details API here to get lat/lng or more info
  }


htmlContent:any

base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

readFile(base64String: string): void {
  const mimeInfo = base64String.substring(0, base64String.indexOf(','));
  const mimeType = mimeInfo.match(/data:([^;]+);/)?.[1] || '';

  const pureBase64 = base64String.split(',')[1];

  if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
    // Handle DOCX
    const arrayBuffer = this.base64ToArrayBuffer(pureBase64);
    mammoth.convertToHtml({ arrayBuffer })
      .then(result => {
        this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(result.value);

      })
      .catch(err => {
        console.error('Error converting .docx:', err);
      });

  } else if (mimeType === 'application/pdf') {
    // Handle PDF
    const embedHtml = `<embed src="${base64String}" type="application/pdf" width="100%" height="600px"/>`;
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(embedHtml);

  } else if (mimeType.startsWith('image/')) {
    // Handle Image
    const imageHtml = `<img src="${base64String}" alt="Uploaded Image" style="max-width: 100%; height: auto;" />`;
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(imageHtml);
  
  } else {
    this.htmlContent = `<p style="color: red;">Unsupported MIME type: ${mimeType}</p>`;
  }
}


currentIndex = 0;
currentItem: any;


notificationData:any=[]
updateData() {
  
  this.currentItem = this.notificationData[this.currentIndex];
  this.currentIndex = (this.currentIndex + 1) % this.notificationData.length;
  // console.log(this.currentItem)
  if(this.currentItem?.source)
  {
  this.readFile(this.currentItem.source)}
}




notificationlist(){

  this.NotificationSettingsService
  .QueueAlllist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.notificationData = data?.filter((item: any) => {
  return item?.userUid
    ?.split(',')
    .map((uid:any) => uid?.trim())?.includes(this.tokenData?.userUuid);
})||[];
   if(this.notificationData){
    if(this.notificationData?.length!=0){
      this.updateData();
      if(this.notificationData?.length!=1){

      setInterval(() => this.updateData(), 6000);}
    }
   }
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
}
